import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-10 px-5 bg-white border-y-4 border-gold scroll-mt-4" data-id="element-126">
      <div className="text-center mb-6" data-id="element-127">
        <h2 className="text-xl font-heading font-bold text-petrol mb-4" data-id="element-128">
          OFFERTA SPECIALE — SISTEMA COMPLETO 6-in-1
        </h2>
        <p className="text-sm text-graphite mb-6" data-id="element-129">
          Accedi oggi stesso al sistema che sta aiutando coach e professionisti
          del fitness a lavorare in modo più intelligente.
        </p>

        <p className="font-subheading font-bold text-sm text-petrol mb-4" data-id="element-130">
          FUNCTIONAL READY™ 6-in-1 Complete System
        </p>

        <a href="#pricing" className="block mb-6" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/h9zfmASQDwvzTrNnkPRn2A/ChatGPT-Image-16-jun-2026_-21_22_56.webp" alt="FUNCTIONAL READY 6-in-1 Complete System" className="w-full max-w-[240px] mx-auto object-contain" loading="lazy" data-id="element-132" />
        </a>
      </div>

      <div className="bg-cream border-2 border-petrol p-5 text-center mb-6" data-id="element-133">
        <p className="text-sm font-bold text-graphite mb-1" data-id="element-134">
          Prezzo Normale: <span className="line-through" data-id="element-135">€97</span>
        </p>
        <p className="text-sm font-subheading font-bold text-[#D9381E] mb-2" data-id="element-136">
          🔥 OFFERTA DI LANCIO — SCONTO DEL 72%
        </p>
        <p className="text-5xl font-heading font-bold text-petrol mb-2" data-id="element-137">
          Solo €24
        </p>
        <p className="text-xs font-bold text-graphite uppercase" data-id="element-138">
          Pagamento Sicuro
        </p>
      </div>

      <div className="bg-[#FFF5F3] border border-[#FFDCD3] p-4 mb-6 text-center" data-id="element-139">
        <p className="text-xs font-bold text-[#D9381E] mb-2" data-id="element-140">
          🔥 Ultima possibilità! Il prezzo aumenterà allo scadere del timer.
        </p>
        <div className="text-xl font-subheading font-bold text-petrol" data-id="element-141">
          {String(timeLeft.hours).padStart(2, '0')} ORE :{' '}
          {String(timeLeft.minutes).padStart(2, '0')} MINUTI :{' '}
          {String(timeLeft.seconds).padStart(2, '0')} SECONDI
        </div>
      </div>

      <div className="mb-4" data-id="element-142">
        <CTAButton href="https://functional-ready.impultienda.ar/checkout" data-id="element-143">
          🚀 SÌ, VOGLIO IL SISTEMA COMPLETO
        </CTAButton>
      </div>

      <div className="flex flex-col gap-2 text-xs text-graphite font-bold text-center" data-id="element-144">
        <div data-id="element-145">⭐ 4.9/5 — Recensioni Verificate</div>
        <div data-id="element-146">🛡️ Garanzia di 7 Giorni — Zero Rischi</div>
      </div>
    </section>;
}